import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as DeletedSectionsActions from './deleted-section.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class DeletedSectionsStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.DELETED_SECTIONS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Get:
          this.store.dispatch(new DeletedSectionsActions.DeletedSectionsRefresh(data.id));
          break;
      }
    });
  }
}
